import React, {useEffect, useLayoutEffect} from 'react';
import {useSelector} from 'react-redux';
import {PageLayoutHorizontalRows} from 'layout';
import {
  FilesEditFooter,
  FilesEditHeader,
  FilesEditDetails,
  FilesEditLearningPaths,
  FilesEditResourceForm,
} from './components';
import {useFileEdit, useFileIdParam} from './hooks';
import {usePrefetchResourceMetadataLookups} from 'filters-selections';
import {fileDetailsFormRevisionSelector} from './store';

export const FilesEditView = () => {
  const {fetchFileById, clearFileDetails, fileDetails} = useFileEdit();
  const {fileId} = useFileIdParam();
  const formRevision = useSelector(fileDetailsFormRevisionSelector);

  usePrefetchResourceMetadataLookups();

  const detailsReady = !!fileDetails && String(fileDetails.id) === String(fileId);
  // Remount when the record first loads and again after each successful save so
  // Formik initialValues hydrate from the latest Redux fileDetails.
  const formKey = detailsReady ? `${fileDetails.id}-r${formRevision}` : `loading-${fileId}`;

  // Drop the previous record before paint so controls never keep stale values.
  useLayoutEffect(() => {
    clearFileDetails();
  }, [clearFileDetails, fileId]);

  useEffect(() => {
    if (fileId) {
      fetchFileById(fileId);
    }

    return () => {
      clearFileDetails();
    };
  }, [clearFileDetails, fetchFileById, fileId]);

  return (
    <FilesEditResourceForm key={formKey}>
      <PageLayoutHorizontalRows
        headerSize="large"
        loading={!detailsReady}
        header={<FilesEditHeader />}
        contentUp={<FilesEditDetails />}
        contentMiddle={<FilesEditLearningPaths />}
        footer={<FilesEditFooter />}
      />
    </FilesEditResourceForm>
  );
};
